import { render, staticRenderFns } from "./academic_font_management_sub.vue?vue&type=template&id=7627c2a6&scoped=true&"
import script from "./academic_font_management_sub.vue?vue&type=script&lang=js&"
export * from "./academic_font_management_sub.vue?vue&type=script&lang=js&"
import style0 from "./academic_font_management_sub.vue?vue&type=style&index=0&id=7627c2a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7627c2a6",
  null
  
)

export default component.exports